import { LogLevel } from "@azure/msal-browser";

const REACT_APP_CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
const REACT_APP_REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI;
const REACT_APP_KNOWN_AUTHORITIES = process.env.REACT_APP_KNOWN_AUTHORITIES?.split(',') || [];
const REACT_APP_AUTHORITY = process.env.REACT_APP_AUTHORITY;
const REACT_APP_B2C_SCOPE = process.env.REACT_APP_B2C_SCOPE;
const REACT_APP_POST_LOGOUT_REDIRECT_URI = process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI;

export const msalconfig={
    auth:{
        clientId:REACT_APP_CLIENT_ID,
        redirectUri: REACT_APP_REDIRECT_URI,
        postLogoutRedirectUri: REACT_APP_POST_LOGOUT_REDIRECT_URI,
        knownAuthorities: ['nideid.b2clogin.com'],
        authority: REACT_APP_AUTHORITY,
        // changePasswordUri: environment.msal_change_password_url
    },
    cache: {
        cacheLocation: "localStorage",
    },
  
};
export const loginRequest = {
    scopes: ["https://nideid.onmicrosoft.com/c537a1f5-ebc5-4d30-919f-3fd171f1f69d/SBMA"]
};
